import React, { useEffect, useState } from 'react';
import { useToasts } from 'react-toast-notifications';
import { Row, Col, ListGroup, ListGroupItem } from 'reactstrap';
import { ExpandableBox } from '@galop/component-library';
import { makeCall } from '../../auth-utils';
import { api, globalErrorHandler } from '../../api/create-api';

export const Counts = (props) => {
    const { addToast } = useToasts();
    const { selectedAsset } = props;
    const [showTotals, setShowTotals] = useState(false);
    const [leaseDetailCounts, setLeaseDetailCounts] = useState({
        'Evictions Filed': null,
        'ERA Applications': null,
        'CDC Declarations': null,
    });

    useEffect(() => getLeaseDetailCounts(), [selectedAsset]);

    const getLeaseDetailCounts = () => {
        if (selectedAsset) {
            makeCall(async (authHeader) => {
                const result = await api(`api/leases/counts/${selectedAsset.id}`, {
                    headers: authHeader
                })
                    .catch(error => globalErrorHandler(error, addToast));

                if (result && result.data) {
                    const newCounts = { ...leaseDetailCounts };
                    newCounts['Evictions Filed'] = result.data.evictions;
                    newCounts['ERA Applications'] = result.data.era;
                    newCounts['CDC Declarations'] = result.data.cdc;
                    setLeaseDetailCounts(newCounts);
                }
            });
        }
    };

    const numOr0 = n => isNaN(n) ? 0 : n;

    return ( selectedAsset && 
        <Row className={props.className}>
            {
                Object.keys(leaseDetailCounts).map((type) =>
                    <Col key={`${type}_${(leaseDetailCounts[type] || []).length}`}>
                        <ExpandableBox IsOpen={showTotals} Toggle={() => setShowTotals(!showTotals)} ShowButton>
                            <ListGroup className=" m-1" flush>
                                <ListGroupItem className="p-1 border-secondary">
                                    <div className="d-flex">
                                        <div className="flex-fill border-right pr-2 mr-2">Total {type}</div>
                                        <div className="text-right" style={{ width: 40 }}><span>{leaseDetailCounts[type] ? leaseDetailCounts[type].reduce((a, b) => numOr0(a) + numOr0(b.count), 0) : '...'}</span></div>
                                    </div>
                                </ListGroupItem>
                                {showTotals &&
                                    (leaseDetailCounts[type] || []).sort((a, b) => b.count - a.count).map(status =>
                                        <ListGroupItem key={`${type}_${status.name}`} className="p-1">
                                            <div className="d-flex">
                                                <div className="flex-fill border-right pr-2 mr-2">{status.status}</div>
                                                <div className="text-right" style={{ width: 40 }}><span>{status.count}</span></div>
                                            </div>
                                        </ListGroupItem>
                                    )}
                            </ListGroup>
                        </ExpandableBox>
                    </Col>
                )
            }
        </Row>
    );
};


// WEBPACK FOOTER //
// ./src/components/LeaseDetails/Counts.js